import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'flowbite';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Home
} from "./pages";
ReactDOM.render(
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
    </Routes>
  </Router>,
  document.getElementById('root')
);